import r, { cloneElement as l, isValidElement as c, useState as a } from "react";
function f(_ref, o) {
  let {
    children: t,
    freeze: e
  } = _ref;
  let n = u(e, t);
  return c(n) ? l(n, {
    ref: o
  }) : r.createElement(r.Fragment, null, n);
}
const s = r.forwardRef(f);
function u(t, e) {
  let [o, n] = a(e);
  return !t && o !== e && n(e), t ? o : e;
}
export { s as Frozen, u as useFrozenData };